/**
 * OCAMAR — Acceso a favoritos en el encabezado.
 * Inserta un corazon con contador junto al carrito, sin tocar los archivos
 * del tema (asi sobrevive a futuras actualizaciones de Horizon).
 */
(function () {
  'use strict';

  var HREF = '/pages/favoritos';

  function injectStyles() {
    if (document.getElementById('ocamar-fav-link-styles')) return;
    var style = document.createElement('style');
    style.id = 'ocamar-fav-link-styles';
    style.textContent = [
      '.ocamar-fav-link{position:relative;display:inline-flex;align-items:center;justify-content:center;',
      'min-width:44px;min-height:44px;color:inherit;text-decoration:none;}',
      '.ocamar-fav-link svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.5;}',
      '.ocamar-fav-link[data-has-items="true"] svg{fill:#9e514f;stroke:#9e514f;}',
      '.ocamar-fav-link__count{position:absolute;top:4px;right:2px;min-width:16px;height:16px;',
      'display:grid;place-items:center;padding:0 4px;border-radius:999px;background:#9e514f;color:#fffdfc;',
      'font-size:10px;font-weight:700;line-height:1;}',
      '.ocamar-fav-link__count[hidden]{display:none;}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildLink() {
    var link = document.createElement('a');
    link.className = 'header-actions__action ocamar-fav-link';
    link.href = HREF;
    link.setAttribute('aria-label', 'Mis favoritos');
    link.innerHTML = [
      '<span class="svg-wrapper" aria-hidden="true">',
      '  <svg viewBox="0 0 24 24">',
      '    <path d="M12 20.3 4.6 13a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l.9.9.9-.9a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5Z"/>',
      '  </svg>',
      '</span>',
      '<span class="ocamar-fav-link__count" data-ocamar-wishlist-count hidden>0</span>'
    ].join('');
    return link;
  }

  function syncState(link) {
    var count = 0;
    try {
      var raw = window.localStorage.getItem('ocamar:wishlist');
      var list = raw ? JSON.parse(raw) : [];
      count = Array.isArray(list) ? list.length : 0;
    } catch (e) {
      count = 0;
    }
    link.setAttribute('data-has-items', count > 0 ? 'true' : 'false');
    var badge = link.querySelector('[data-ocamar-wishlist-count]');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
  }

  function mount() {
    var containers = document.querySelectorAll('header-actions');
    if (containers.length === 0) return false;

    injectStyles();

    containers.forEach(function (container) {
      if (container.querySelector('.ocamar-fav-link')) return;

      var link = buildLink();
      /* Lo insertamos justo antes del carrito para que quede a su izquierda. */
      var cart = container.querySelector('[aria-controls="cart-drawer"], .action__cart');
      if (cart) {
        container.insertBefore(link, cart);
      } else {
        container.appendChild(link);
      }

      syncState(link);
      document.addEventListener('ocamar:wishlist:change', function () { syncState(link); });
    });

    return true;
  }

  if (!mount()) {
    /* El encabezado puede montarse despues (hidratacion del tema). */
    var observer = new MutationObserver(function () {
      if (mount()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);
  }
})();
